import lib from '@/library'

const actions = {
  fetchBettingParams (context) {
    // console.log('sbBetslipState fetchBettingParams')
    context.dispatch('fetchCoreParams')
    context.dispatch('fetchBetSlipParams')
  },
  fetchBetSlipParams (context) {
    // console.log('sbBetslipState fetchBetSlipParams')
    var map = {
      TXMaxBetSlipTotalStake: !'setSlipTotalStakeMax',
      TXMaxBetSlipTotalStakeInRunning: 'setSlipTotalStakeMaxInPlay',
      TXMaxUnitStake: 'setUnitStakeMax',
      TXStakeMinUnit: 'setUnitStakeMin',
      TXMultiStakeMinUnit: 'setMultiStakeMinUnit',
      TxMaxPotentialSlipPayout: !'setMaxPotentialSlipPayout',
      TxSlipTotalStakeMin: !'setSlipTotalStakeMin',
      TxUnitStakeIncrement: !'setUnitStakeIncrement'
    }
    var parseResponse = function (response) {
      for (var i = 0; i < response.length; i++) {
        var item = response[i]
        if (map[item.Code]) {
          var val = item.Value ? parseFloat(item.Value) : item.Value
          if (val && typeof val === 'number' && val > 0) {
            // console.log(item.Code + ': ' + val)
            console.log(map[item.Code] + ': ' + val)
            context.commit(map[item.Code], val)
          }
        }
      }
    }

    return new Promise((resolve) => {
      lib.kansas.psParams({
        csvlist: 'TXStakeMinUnit,TXMaxUnitStake,TXMultiStakeMinUnit,TXMaxBetSlipTotalStake,TXMaxBetSlipTotalStakeInRunning,TxSlipTotalStakeMin,TxMaxPotentialSlipPayout,TxUnitStakeIncrement,TXStakeMaxUnit'
      }).then(response => {
        // console.log(response)
        if (response && response.data) {
          parseResponse(response.data)
          // gedDisputeInfoFromResponse(response.data)
        }
      }).catch((error) => {
        console.log('fetchBetSlipParams error')
        console.log(error)
      }).finally(() => {
        resolve()
      })
    })
  },
  fetchCoreParams (context) {
    // console.log('sbBetslipState fetchCoreParams')
    var map = {
      IsFOPreferredInSingles: 'isFOPreferredInSingles',
      IsFPPreferredInMultiples: 'isFPPreferredInMultiples'
    }
    var parseResponse = function (response) {
      // console.log('parse fetchCoreParams Response')
      for (var i = 0; i < response.length; i++) {
        var item = response[i]
        // console.log(item)
        var val = item.Value
        var handler = map[item.Code]
        if (val && handler) {
          console.log(item.Code + ': ' + val)
          context.commit(handler, val)
        }
      }
    }

    return new Promise((resolve) => {
      lib.kansas.psCoreParams({
        csvlist: 'IsFOPreferredInSingles,IsFPPreferredInMultiples',
        iddcapplication: 'MMFO'
      }).then(response => {
        // console.log(response)
        if (response && response.data) {
          parseResponse(response.data)
        }
      }).catch((error) => {
        console.log('fetchCoreParams error')
        console.log(error)
      }).finally(() => {
        resolve()
      })
    })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/sports/betslip/actions/fetchParams.js